import React from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import AddToList from '../../assets/icons/AddToList';
import RemoveFromList from '../../assets/icons/RemoveFromList';
import { colorsPalette } from '../../theme';
import { LightTooltip } from '../UI/LightTooltip';

const useStyles = (noBackground, disabled) =>
  makeStyles(() =>
    createStyles({
      wrapper: {
        width: noBackground ? 'initial' : 40,
        height: noBackground ? 'initial' : 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        background: noBackground ? 'initial' : colorsPalette.violetAnalyticsCard,
        cursor: 'pointer',
        opacity: disabled ? 0.3 : 1,
        pointerEvents: disabled ? 'none' : 'initial',
        transition: 'opacity 0.6s',
      },
      icon: {
        position: 'relative',
        top: 2,
        left: 2,
      },
    }),
  );

const ToggleFromList = ({ isAdd = true, onClick, noBackground = false, disabled = false }) => {
  const classes = useStyles(noBackground, disabled)();
  const { t } = useTranslation();

  return (
    <LightTooltip
      placement="top"
      // @ts-ignore
      title={isAdd ? t('common.addToWatchlist') : t('common.removeFromWatchlist')}
    >
      <div className={classes.wrapper} onClick={onClick}>
        {isAdd ? (
          <AddToList className={classes.icon} />
        ) : (
          <RemoveFromList className={classes.icon} />
        )}
      </div>
    </LightTooltip>
  );
};

export default ToggleFromList;
